<template src="./NameModal.html"></template>
<script>
/**
 * 名前モーダルコンポーネント
 * @vue-props {string} name モーダル名
 * @vue-computed {boolean} isVisible モーダルが表示中なら真
 * @module Modal/NameModal
 */
export default {
  name: 'NameModal',
  props: {
    name: {
      type: String,
      required: true,
    },
    /**
     * モーダルコンテンツの背景色を透明にするかどうか
     * @type {boolean}
     */
    transparentBackground: {
      type: Boolean,
      default: false,
    },
    /**
     * modal-body の padding を無効化するかどうか
     * @type {boolean}
     */
    noBodyPadding: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isVisible() {
      return this.$store.getters['isVisible'][this.name];
    },
    /**
     * モーダルコンテナのスタイル
     * @returns {Object}
     */
    modalContainerStyle() {
      const style = { top: '30px' };
      if (this.transparentBackground) {
        style.backgroundColor = 'transparent';
      }
      return style;
    },
    /**
     * モーダルボディのスタイル
     * @returns {Object}
     */
    modalBodyStyle() {
      if (this.noBodyPadding) {
        return { padding: 0 };
      }
      return {};
    },
  },
  methods: {
    /**
     * モーダルを非表示にする
     * @return {void}
     */
    hide() {
      this.$store.commit('hide', this.name);
    },
  },
};
</script>
